import React from 'react'
import Text from "./types/text"
import "./index.css"
import Dropdown from './types/dropdown'
import Checkbox from './types/checkbox'
import MCQ from './types/mcq'

const Input = React.memo(props => {
    const { type, min, max, onEditComplete, onFocusChange, post, options, def, ki, label, viewOnly, placeholder } = props
    switch (type) {
        case 'select':
            return <Dropdown
                type={type}
                onEditComplete={onEditComplete}
                onFocusChange={onFocusChange}
                options={options}
                def={def}
                key={`ip-${ki}`}
                viewOnly={viewOnly}
            />
        case 'bool':
            return <Dropdown
                type={type}
                onEditComplete={onEditComplete}
                onFocusChange={onFocusChange}
                options={(options || ['Yes', 'No']).slice(0, 2).map((o, i) => { return { name: o, value: i % 2 == 0 } })}
                def={def}
                key={`ip-${ki}`}
                viewOnly={viewOnly}
            />
        case 'checkbox':
            return <Checkbox
                onEditComplete={onEditComplete}
                onFocusChange={onFocusChange}
                def={def}
                key={`ip-${ki}`}
                label={label}
                viewOnly={viewOnly}
            />
        case 'mcq':
            return <MCQ
                onEditComplete={onEditComplete}
                onFocusChange={onFocusChange}
                options={options}
                def={def}
                post={post}
                key={`ip-${ki}`}
                label={label}
                viewOnly={viewOnly}
            />
        default:
            return <Text
                type={type}
                min={min}
                max={max}
                onEditComplete={onEditComplete}
                onFocusChange={onFocusChange}
                post={post}
                def={def}
                key={`ip-${ki}`}
                viewOnly={viewOnly}
                placeholder={placeholder}
            />
    }
})

export default Input

